const STORAGE_KEY = `${process.env.NEXT_PUBLIC_STORE_VIEW_CODE}-cart-column`;

export const setCartPageColumn = (column: 'home' | 'attire') => {
  try {
    window.localStorage.setItem(STORAGE_KEY, column);
  } catch (error) {
    console.error(error);
  }
};

export const getCartPageColumn = () => {
  try {
    const column = window.localStorage.getItem(STORAGE_KEY);

    return column === 'attire' ? 'attire' : 'home';
  } catch (error) {
    return 'home';
  }
};
